function getCookieValue(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

window.showShareCart = () => {
  const cookieValue = getCookieValue('mf_lac_logged');
  if (cookieValue) {
    setTimeout(() => {
      const shareCartEl = document.querySelector('.container-share-cart');
      if (shareCartEl) shareCartEl.style.opacity = 1;
    }, 1000);
  }
};

const observeShareCart = () => {
  const shareCartEl = document.querySelector('.container-share-cart');
  if (!shareCartEl) return;

  const observer = new MutationObserver(() => {
    if (shareCartEl.innerHTML.trim()) {
      sessionStorage.setItem('shareCartContent', shareCartEl.innerHTML);
    }
  });

  observer.observe(shareCartEl, { childList: true, subtree: true });

  if (shareCartEl.innerHTML.trim()) {
    sessionStorage.setItem('shareCartContent', shareCartEl.innerHTML);
  }
};

window.showShareCart();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeShareCart);
} else {
  setTimeout(observeShareCart, 100);
}
